





























































































































































































































































    import { Component } from "vue-property-decorator";
    import { Guid } from 'guid-typescript';
    
    import { mixins } from "vue-class-component";
	import SharedMixin from "@/mixins/SharedMixin";
    
    import { CustomerOrderStore } from "../../CustomerOrderStore";
    import { SectionStore } from "../../SectionStore";

    import { deepComparison, IsMobile, SharedModule } from "@/feature/Shared/store";
    
    // Header
    import PgaOfferEvaluationHeaderCustomerOrderEdit from "./sub-components/PgaOfferEvaluationHeaderCustomerOrderEdit.vue";
    // Fixed Price Project
    import PgaOfferEvaluationFixedPriceProjectCreate from "../create/sub-components/PgaOfferEvaluationFixedPriceProjectCreate.vue";
    // Human Resources
    import PgaOfferEvaluationHumanResourcesCreate from"../create/sub-components/PgaOfferEvaluationHumanResourcesCreate.vue";
    import PgaOfferEvaluationHumanResourcesSubtotals from "../create/sub-components/sub-totals/PgaOfferEvaluationHumanResourcesSubtotals.vue";
    // Other Components
    import PgaOfferEvaluationOtherComponentsProductCreate from "../create/sub-components/other-components/PgaOfferEvaluationOtherComponentsProductCreate.vue";
    import PgaOfferEvaluationOtherComponentsSolutionCreate from "../create/sub-components/other-components/PgaOfferEvaluationOtherComponentsSolutionCreate.vue";
    import PgaOfferEvaluationOtherComponentsServiceCreate from "../create/sub-components/other-components/PgaOfferEvaluationOtherComponentsServiceCreate.vue";
    import PgaOfferEvaluationOtherComponentsTransferCreate from "../create/sub-components/other-components/PgaOfferEvaluationOtherComponentsTransferCreate.vue";
    import PgaOfferEvaluationOtherComponentsSecurityCreate from "../create/sub-components/other-components/PgaOfferEvaluationOtherComponentsSecurityCreate.vue";
    import PgaOfferEvaluationOtherComponentsOthersCreate from "../create/sub-components/other-components/PgaOfferEvaluationOtherComponentsOthersCreate.vue";
    import PgaOfferEvaluationOtherComponentsSubtotals from "../create/sub-components/sub-totals/PgaOfferEvaluationOtherComponentsSubtotals.vue";
    // TotalAmounts
    import PgaOfferEvaluationTotalAmountsCreate from "../create/sub-components/PgaOfferEvaluationTotalAmountsCreate.vue";
    import PgaOfferEvaluationTotalAmountsDiscountedCreate from "../create/sub-components/PgaOfferEvaluationTotalAmountsDiscountedCreate.vue";
    // Additional Costs Presale
    import PgaOfferEvaluationAdditionalCostsPresaleCreate from "../create/sub-components/PgaOfferEvaluationAdditionalCostsCreate.vue";
    import PgaOfferEvaluationAdditionalCostsPresaleSubtotals from "../create/sub-components/sub-totals/PgaOfferEvaluationAdditionCostsPresaleSubtotals.vue";
    // Other Costs
    import PgaOfferEvaluationOtherCostsPresaleCreate from "../create/sub-components/PgaOfferEvaluationOtherCostsCreate.vue";
    import PgaOfferEvaluationOtherCostsPresaleSubtotals from "../create/sub-components/sub-totals/PgaOfferEvaluationOtherCostsPresaleSubtotals.vue";
    // Total Costs Presale/Postsale
    import PgaOfferEvaluationTotalCostsCreate from "../create/sub-components/PgaOfferEvaluationTotalCostsCreate.vue";
    // Additional Costs Postsale
    import PgaOfferEvaluationAdditionalCostsMaintenancePostsaleCreate from "../create/sub-components/additional-costs-postsale/PgaOfferEvaluationAdditionalCostsPostsaleMaintenanceCreate.vue";
    import PgaOfferEvaluationAdditionalCostsWarrantyPostsaleCreate from "../create/sub-components/additional-costs-postsale/PgaOfferEvaluationAdditionalCostsPostsaleWarrantyCreate.vue";
    import PgaOfferEvaluationAdditionalCostsSupportPostsaleCreate from "../create/sub-components/additional-costs-postsale/PgaOfferEvaluationAdditionalCostsPostsaleSupportCreate.vue";
    import PgaOfferEvaluationAdditionalCostsOthersPostsaleCreate from "../create/sub-components/additional-costs-postsale/PgaOfferEvaluationAdditionalCostsPostsaleOthersCreate.vue";
    // Totals Offer Evaluation
    import PgaOfferEvaluationTotalsOfferEvaluationCreate from "../create/sub-components/PgaOfferEvaluationTotalsOfferEvaluationCreate.vue";
    import PgaOfferEvaluationExpectedRevenueCreate from "../create/sub-components/PgaOfferEvaluationExpectedRevenueCreate.vue";
    // Attachments
    import PgaOfferEvaluationAttachmentsCreate from "../create/sub-components/PgaOfferEvaluationAttachmentsCreate.vue";

	@Component( {
        components:
        {
            PgaOfferEvaluationHeaderCustomerOrderEdit,

            PgaOfferEvaluationFixedPriceProjectCreate,

            PgaOfferEvaluationHumanResourcesCreate,
            PgaOfferEvaluationHumanResourcesSubtotals,

            PgaOfferEvaluationOtherComponentsProductCreate,
            PgaOfferEvaluationOtherComponentsSolutionCreate,
            PgaOfferEvaluationOtherComponentsServiceCreate,
            PgaOfferEvaluationOtherComponentsTransferCreate,
            PgaOfferEvaluationOtherComponentsSecurityCreate,
            PgaOfferEvaluationOtherComponentsOthersCreate,
            PgaOfferEvaluationOtherComponentsSubtotals,

            PgaOfferEvaluationTotalAmountsCreate,
            PgaOfferEvaluationTotalAmountsDiscountedCreate,

            PgaOfferEvaluationAdditionalCostsPresaleCreate,
            PgaOfferEvaluationAdditionalCostsPresaleSubtotals,

            PgaOfferEvaluationOtherCostsPresaleCreate,
            PgaOfferEvaluationOtherCostsPresaleSubtotals,

            PgaOfferEvaluationTotalCostsCreate,

            PgaOfferEvaluationAdditionalCostsMaintenancePostsaleCreate,
            PgaOfferEvaluationAdditionalCostsWarrantyPostsaleCreate,
            PgaOfferEvaluationAdditionalCostsSupportPostsaleCreate,
            PgaOfferEvaluationAdditionalCostsOthersPostsaleCreate,

            PgaOfferEvaluationTotalsOfferEvaluationCreate,
            PgaOfferEvaluationExpectedRevenueCreate,

            PgaOfferEvaluationAttachmentsCreate,
        }
    })
    export default class PgaOfferEvaluationCustomerOrderCreate extends mixins(SharedMixin)
    {
        private readonly customerOrderResource = "customerorder";
        private isMiniVariant = this.isMobile;

        get editRestricted() : boolean
        {
            return !SharedModule.Permissions.includes('EditOfferEvaluationCustomerOrder')
                && SharedModule.Permissions.includes('EditOfferEvaluationCustomerOrderRestricted');
        }
        
        get isMobile() : boolean
        {
            return IsMobile(this.$vuetify.breakpoint.name);
        }

        get panelsOpened() : Array<number>
        {
            return [0, 1, 2, 3, 4, 5, 6];
        }

        // Errors check
        get hasErrorsFixedPrice() : boolean
        {
            return SectionStore.EditFixedPriceProject.Errors.size > 0;
        }
        get hasErrorsHumanResources() : boolean
        {
            return SectionStore.EditHumanResources.Errors.size > 0;
        }
        get hasErrorsOtherComponents() : boolean
        {
            return SectionStore.EditOtherComponents.Errors.size > 0;
        }
        get hasErrorsAdditionalCostsPresale() : boolean
        {
            return SectionStore.EditAdditionalCostsPresale.Errors.size > 0;
        }
        get hasErrorsOtherCostsPresale() : boolean
        {
            return SectionStore.EditOtherCostsPresale.Errors.size > 0;
        }
        get hasErrorsAdditionalCostsPostsale() : boolean
        {
            return SectionStore.EditAdditionalCostsPostsale.Errors.size > 0;
        }
        get hasErrorsAttachments() : boolean
        {
            return SectionStore.EditAttachments.Errors.size > 0;
        }

        // Sections: handle single rows
        get humanResourcesCount() : number
        {
            return SectionStore.EditHumanResources.Command.Resources.length;
        }
        private addHumanResource()
        {
            SectionStore.SET_EDIT_HUMANRESOURCES_ADD_NEW_RESOURCE();
        }

        get otherComponentsCount() : number
        {
            return SectionStore.EditOtherComponents.Command.Others.length;
        }
        private addOtherComponent()
        {
            SectionStore.SET_EDIT_OTHERCOMPONENTS_ADD_NEW_COMPONENT();
        }

        get additionalCostsPresaleCount() : number
        {
            return SectionStore.EditAdditionalCostsPresale.Command.AdditionalCosts.length;
        }
        private addAdditionalCostsPresale()
        {
            SectionStore.SET_EDIT_ADDITIONALCOSTSPRESALE_ADD_NEW_ELEMENT();
        }

        get otherCostsPresaleCount() : number
        {
            return SectionStore.EditOtherCostsPresale.Command.OtherCosts.length;
        }
        private addOtherCostsPresale()
        {
            SectionStore.SET_EDIT_OTHERCOSTSPRESALE_ADD_NEW_ELEMENT();
        }

        get otherCostsPostsaleCount() : number
        {
            return SectionStore.EditAdditionalCostsPostsale.Command.Others.length;
        }
        private addOtherCostsPostsale()
        {
            SectionStore.SET_EDIT_ADDITIONALCOSTSPOSTSALE_ADD_NEW_ELEMENT();
        }

        get showMiniVariant() : boolean
        {
            return this.isMobile && this.isMiniVariant;
        }

        private changeMiniVariant() : void
        {
            this.isMiniVariant = !this.isMiniVariant;
        }

        private async SaveAsDraft() : Promise<void>
        {
            SharedModule.SET_ISLOADING(true);
            let allSaved = true;
            try
            {
                await CustomerOrderStore.EditOfferEvaluationCustomerOrder();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditFixedPriceProject.Command, SectionStore.EditFixedPriceProject.CommandCopy))
                    await SectionStore.EditFixedPriceSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditHumanResources.Command, SectionStore.EditHumanResources.CommandCopy))
                    await SectionStore.EditHumanResourcesSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditOtherComponents.Command, SectionStore.EditOtherComponents.CommandCopy))
                    await SectionStore.EditOtherComponentsSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditTotalAmountsSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditAdditionalCostsPresale.Command, SectionStore.EditAdditionalCostsPresale.CommandCopy))
                    await SectionStore.EditAdditionalCostsPresaleSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditOtherCostsPresale.Command, SectionStore.EditOtherCostsPresale.CommandCopy))
                    await SectionStore.EditOtherCostsPresaleSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditAdditionalCostsPostsale.Command, SectionStore.EditAdditionalCostsPostsale.CommandCopy))
                    await SectionStore.EditAdditionalCostsPostsaleSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditTotalExpectedRevenueByFeeSectionDraft();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                if(!deepComparison(SectionStore.EditAttachments.Command, SectionStore.EditAttachments.CommandCopy)
                    || SectionStore.UploadFiles.Command.Files.length > 0)
                    await SectionStore.EditAttachmentsSection();
            }
            catch
            {
                allSaved = false;
            }
            SharedModule.SET_ISLOADING(false);
            if(allSaved)
            {
                this.$router.go(-1);
            }
        }

        private async Save() : Promise<void>
        {
            SharedModule.SET_ISLOADING(true);
            let allSaved = true;
            try
            {
                await CustomerOrderStore.EditOfferEvaluationCustomerOrder();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditFixedPriceSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditHumanResourcesSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditOtherComponentsSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditTotalAmountsSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditAdditionalCostsPresaleSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditOtherCostsPresaleSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditAdditionalCostsPostsaleSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditTotalExpectedRevenueByFeeSection();
            }
            catch
            {
                allSaved = false;
            }
            try
            {
                await SectionStore.EditAttachmentsSection();
            }
            catch
            {
                allSaved = false;
            }
            SharedModule.SET_ISLOADING(false);

            if(allSaved)
            {
                await CustomerOrderStore.SaveOfferEvaluationCustomerOrder();
                this.$router.go(-1);
            }
        }

        private async SaveRestricted() : Promise<void>
        {
            SharedModule.SET_ISLOADING(true);
            await CustomerOrderStore.EditOfferEvaluationCustomerOrder();
            SharedModule.SET_ISLOADING(false);
            this.$router.go(-1);
        }

        private undo() : void
        {
            this.$router.go(-1);
        }
        
        async mounted() : Promise<void>
        {
            const id = Guid.parse(this.$route.params.id);
            await CustomerOrderStore.InitEditCustomerOrderCommand(id);
            SectionStore.SET_OFFER_EVALUATION_TYPE(this.customerOrderResource);
        }

        beforeDestroy() : void
		{
            SectionStore.ResetEditFixedPriceSectionCommand();
			SectionStore.ResetEditHumanResourcesSectionCommand();
            SectionStore.ResetEditOtherComponentsSectionCommand();
            SectionStore.ResetEditTotalAmountsSectionCommand();
            SectionStore.ResetEditAdditionalCostsPresaleSectionCommand();
            SectionStore.ResetEditOtherCostsPresaleSectionCommand();
            SectionStore.ResetEditAdditionalCostsPostsaleSectionCommand();
            SectionStore.ResetEditTotalExpectedRevenueByFeeSectionCommand();
            SectionStore.ResetEditAttachmentsSectionCommand();
            CustomerOrderStore.ResetSaveCustomerOrderCommand();
            CustomerOrderStore.ResetEditCustomerOrderCommand();
		}
    }
